import React, { useState } from 'react';
import { MainSale } from './pages/MainSale';
import SavedProductsContext from './SavedProductsContext';

import { usePromiseTracker } from 'react-promise-tracker';
import Loader from 'react-promise-loader';

function App() {

  let productsLocal = JSON.parse(localStorage.getItem('products')) || {};
  let productsQtyLocal = JSON.parse(localStorage.getItem('productsQty')) || {};

  let [ products, setProducts ] = useState(productsLocal);
  let [ productsQty, setProductsQty ] = useState(productsQtyLocal);

  return (
    <SavedProductsContext.Provider value={[ products, setProducts, productsQty, setProductsQty ]}>
      <MainSale>

      </MainSale>
      <Loader promiseTracker={usePromiseTracker} color={'#3d5e61'} background={'rgba(255,255,255,.5)'} />
    </SavedProductsContext.Provider>
  );
}

export default App;
